<template>
  <database-management
    :headings="headings"
    :entries="entries"
    :loading="loading"
    :sort="sort"
    :sort-dir="sortDir"
    @showModal="(id) => {
      selectedEntryId = id
      showModal()
    }"
    @updateSort="(key) => {
      updateSort(key)
    }">
    <template v-slot:heading>Category Management</template>
    <template v-slot:list>
      <category-management-list-item
        v-for="category in sortedEntries"
        :key="category.id"
        :category="category"
        @edit="(id) => {
            selectedEntryId = id
            showModal()
          }"/>
    </template>
    <template v-slot:modal>
      <category-management-modal
        ref="modal"
        :category="selectedEntryIndex !== -1 ? entries[selectedEntryIndex] : defaultEntry"
        @create="(category) => { add(category) }"
        @update="(category) => { update(category) }"
      />
    </template>
  </database-management>
</template>

<script>
import { http } from 'utils'
import CategoryManagementListItem from './CategoryManagementListItem'
import CategoryManagementModal from './CategoryManagementModal'
import DatabaseManagement from './templates/DatabaseManagement'
import { databaseManagement } from 'mixins'

export default {
  mixins: [databaseManagement],
  components: {DatabaseManagement, CategoryManagementModal, CategoryManagementListItem},
  data () {
    return {
      defaultEntryData: {
        name: null,
        currency: null,
        hide_budget: false
      },
      headings: [
        { key: 'name', label: 'Name' },
        { key: 'currency', label: 'Currency' },
        { key: 'hide_budget', label: 'Hide Budget' }
      ]
    }
  },

  created () {
    http.get('categories')
      .then((response) => {
        this.entries = response.data
        this.loading = false
      })
  }
}
</script>
